import { t } from '@lingui/core/macro';
export const sanitizeUserObject = (user) => ({
    id: (user === null || user === void 0 ? void 0 : user.id) || '0',
    name: (user === null || user === void 0 ? void 0 : user.name) || t({ message: 'Unknown name', comment: 'Fallback name for user in pleditor' }),
});
